import React from 'react';
import { Text, StyleSheet } from 'react-native';
import Colors from '../../../../constants/Colors';

interface QueueWidgetProps {
  queueCount: number,
}

const QueueWidget = ({ queueCount }: QueueWidgetProps) => <>
  <Text style={styles.title}>{'Queue now'}</Text>
  <Text style={styles.value}>{queueCount ?? '-'}</Text>
</>;

const styles = StyleSheet.create({
  title: {
    fontSize: 14,
    lineHeight: 22,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack400,
    marginBottom: 4,
  },
  value: {
    fontSize: 18,
    lineHeight: 14,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlack600,
    marginBottom: 16,
  },
});

export default QueueWidget;
